import dayjs from 'dayjs';

const DATE_PROPERTIES = ['start_date', 'end_date'];

const serializeDates = (payload: any): any => {
	const serializedPayload = {...payload};

	DATE_PROPERTIES.forEach((property) => {
		if (Object.prototype.hasOwnProperty.call(payload, property)) {
			serializedPayload[property] = payload[property] == null
				? payload[property]
				: dayjs(payload[property]).format('YYYY-MM-DD');
		}
	});

	return serializedPayload;
};

export const serializeCourseDates = (payload: any): any => {
	const serializedPayload = serializeDates(payload);

	if (payload.course_settings != null) {
		serializedPayload.course_settings = serializeDates(payload.course_settings);
	}

	return serializedPayload;
};
